import actionTypes from "./actionTypes";
import api from "./api";
export default {
    createSummaryReportObjects: (data, summaryReportIds) => ({
        type: actionTypes.CREATE_SUMMARY_REPORT_OBJECTS,
        payload: {
            promise: () => api.createSummaryReportObjects(data, summaryReportIds)
        },
        scope: `${actionTypes.CREATE_SUMMARY_REPORT_OBJECTS}_${data.DocumentId}`
    })
};
